<template>
  <div>
    <custom-actions title="收益金转商城积分">
      <template #header>
        <el-button v-if="canApply" type="primary" @click="openApply">新增</el-button>
      </template>
      <el-form inline :model="search" label-width="110px">
        <el-form-item label="客户名称"><el-input v-model="search.userName" clearable placeholder="请输入客户名称" /></el-form-item>
        <el-form-item label="企业商城ID号"><el-input v-model="search.enterpriseMallId" clearable placeholder="请输入企业商城ID号" /></el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="search.approvalStatus" clearable placeholder="全部">
            <el-option v-for="(label, value) in statuses" :key="value" :label="label" :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="onSearch">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>
    </custom-actions>
    <el-card class="mt10" shadow="never">
      <el-table v-loading="loading" :data="rows" border stripe size="mini">
        <el-table-column label="申请单号" prop="transferNumber" min-width="210" />
        <el-table-column label="客户名称" prop="userName" min-width="180" />
        <el-table-column label="云销账户" prop="loginId" min-width="140" />
        <el-table-column label="企业商城ID号" prop="enterpriseMallId" min-width="170" />
        <el-table-column label="转出金额（元）" prop="transferAmount" min-width="140" />
        <el-table-column label="审批状态" min-width="150"><template v-slot="{ row }">{{ statuses[row.approvalStatus] }}</template></el-table-column>
        <el-table-column label="工单状态" min-width="110"><template v-slot="{ row }">{{ orderStatuses[row.orderStatus] }}</template></el-table-column>
        <el-table-column label="申请时间" prop="ctime" min-width="160" />
        <el-table-column label="操作" width="240" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="openDetail(row)">详情</el-button>
            <el-button v-if="row.orderStatus !== '3'" type="text" :disabled="exporting" @click="download(row)">导出PDF</el-button>
            <el-button v-if="row.canApprove" type="text" @click="openDetail(row, true)">审核</el-button>
            <el-button v-if="row.canCancel" type="text" :disabled="saving" class="del-btn" @click="cancel(row)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="mt15" :current-page.sync="page" :page-size="10" :total="total" background layout="total, prev, pager, next" @current-change="load" />
    </el-card>

    <el-dialog title="新增收益金转商城积分申请" :visible.sync="applyVisible" width="520px" :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving">
      <el-alert title="申请后暂扣未锁定收益金，取消或驳回后返还。" type="info" :closable="false" class="mb15" />
      <el-form ref="applyForm" :model="form" :rules="rules" label-width="130px">
        <el-form-item v-if="isOperator" label="客户名称" prop="userId">
          <el-select v-model="form.userId" filterable clearable :loading="customersLoading" placeholder="请选择客户名称" style="width: 100%">
            <el-option v-for="customer in customers" :key="customer.userId" :value="customer.userId" :label="customer.userName + (customer.loginId ? '（' + customer.loginId + '）' : '')" />
          </el-select>
        </el-form-item>
        <el-form-item label="企业商城ID号" prop="enterpriseMallId"><el-input v-model.trim="form.enterpriseMallId" maxlength="64" placeholder="请输入企业商城ID号" /></el-form-item>
        <el-form-item label="转出金额（元）" prop="transferAmount"><el-input v-model.trim="form.transferAmount" placeholder="请输入转出金额，最多两位小数" /></el-form-item>
      </el-form>
      <template #footer><el-button :disabled="saving" @click="applyVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="submit">提交申请</el-button></template>
    </el-dialog>

    <el-dialog :title="reviewing ? '审核收益金转商城积分申请' : '申请详情'" :visible.sync="detailVisible" width="850px" :close-on-click-modal="false">
      <template v-if="detail">
        <el-form label-width="135px" class="detail-form">
          <el-form-item label="申请单号">{{ detail.transferNumber }}</el-form-item>
          <el-form-item label="客户名称">{{ detail.userName }}</el-form-item>
          <el-form-item label="云销账户">{{ detail.loginId }}</el-form-item>
          <el-form-item label="企业商城ID号">{{ detail.enterpriseMallId }}</el-form-item>
          <el-form-item label="转出金额">{{ detail.transferAmount }} 元</el-form-item>
          <el-form-item label="审批状态">{{ statuses[detail.approvalStatus] }}</el-form-item>
        </el-form>
        <el-form label-width="135px" class="attachment-section">
          <el-form-item label="附件">
            <file-upload v-model="detail.attachments" readonly :has-add="canUploadAttachment" />
          </el-form-item>
        </el-form>
        <el-table :data="detail.recordList || []" border size="mini">
          <el-table-column label="审核节点" prop="approvalName" min-width="140" />
          <el-table-column label="审核人" prop="approver" min-width="110" />
          <el-table-column label="结果" width="90"><template v-slot="{ row }">{{ recordStatuses[row.approvalStatus] }}</template></el-table-column>
          <el-table-column label="审核时间" prop="approvalTime" min-width="150" />
          <el-table-column label="审核意见" prop="approvalComments" min-width="170" />
        </el-table>
        <el-form v-if="reviewing && detail.canApprove" class="mt15" label-width="100px">
          <el-form-item label="审核结果"><el-radio-group v-model="decision"><el-radio label="2">通过</el-radio><el-radio label="3">驳回</el-radio></el-radio-group></el-form-item>
          <el-form-item label="审核意见"><el-input v-model="comments" type="textarea" maxlength="500" show-word-limit /></el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button v-if="detail && detail.orderStatus !== '3'" :loading="exporting" @click="download(detail)">导出PDF</el-button>
        <el-button v-if="reviewing && detail && detail.canApprove" type="primary" :loading="saving" @click="approve">提交审核</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/apis/incomeTransfer'

const emptySearch = () => ({ userName: '', enterpriseMallId: '', approvalStatus: '' })
export default {
  name: 'IncomeTransfer',
  data() {
    const amountRule = (rule, value, done) => {
      const valid = /^(?:0|[1-9]\d{0,15})(?:\.\d{1,2})?$/.test(value) && /[1-9]/.test(value)
      done(valid ? undefined : new Error('请输入大于0的金额，最多16位整数和两位小数'))
    }
    return {
      search: emptySearch(),
      rows: [],
      page: 1,
      total: 0,
      loading: false,
      saving: false,
      exporting: false,
      applyVisible: false,
      detailVisible: false,
      detail: null,
      reviewing: false,
      decision: '2',
      comments: '',
      customers: [],
      customersLoading: false,
      form: { userId: '', enterpriseMallId: '', transferAmount: '' },
      statuses: { 1: '业务员审核', 2: '部门经理审核', 3: '系统管理员审核', 4: '审核通过', 5: '已驳回', 6: '已取消' },
      orderStatuses: { 1: '审批中', 2: '已完成', 3: '已作废' },
      recordStatuses: { 1: '待审核', 2: '通过', 3: '驳回/取消' },
      rules: {
        userId: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
        enterpriseMallId: [{ required: true, message: '请填写企业商城ID号', trigger: 'blur' }],
        transferAmount: [{ validator: amountRule, trigger: 'blur' }]
      }
    }
  },
  computed: {
    isCustomer() { return String(this.$store.state.user.userType || '').split(',').includes('3') },
    isOperator() {
      const user = this.$store.state.user
      return String(user.isAdmin) === '1' || String(user.userType || '').split(',').includes('1')
    },
    canApply() { return this.isCustomer || this.isOperator },
    canUploadAttachment() {
      return (this.$store.state.buttonList || []).some(button => button.butCode === 'addFile')
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const result = await this.$axios.get(api.list, { ...this.search, page: this.page, size: 10 })
        this.rows = result.list || []
        this.total = result.total || 0
      } catch (error) { /* 统一请求拦截器显示错误 */ } finally { this.loading = false }
    },
    onSearch() { this.page = 1; this.load() },
    reset() { this.search = emptySearch(); this.onSearch() },
    openApply() {
      this.form = { userId: this.isCustomer ? this.$store.state.user.userId : '', enterpriseMallId: '', transferAmount: '' }
      this.applyVisible = true
      if (this.isOperator) this.loadCustomers()
      this.$nextTick(() => this.$refs.applyForm.clearValidate())
    },
    async loadCustomers() {
      this.customersLoading = true
      try {
        const result = await this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '3' })
        this.customers = result.list || []
      } catch (error) { /* 统一请求拦截器显示错误 */ } finally { this.customersLoading = false }
    },
    submit() {
      if (this.saving) return
      this.$refs.applyForm.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          // 金额以字符串提交，避免大金额经JS浮点数转换后丢失分位。
          const params = { enterpriseMallId: this.form.enterpriseMallId, transferAmount: this.form.transferAmount }
          if (this.isOperator) params.userId = this.form.userId
          const order = await this.$axios.post(api.apply, params)
          this.applyVisible = false
          this.detail = order; this.reviewing = false; this.detailVisible = true
          this.onSearch()
        } catch (error) { /* 表单保留，便于修正 */ } finally { this.saving = false }
      })
    },
    async openDetail(row, review = false) {
      try {
        this.detail = await this.$axios.get(api.detail, { transferId: row.transferId })
        this.reviewing = review; this.decision = '2'; this.comments = ''; this.detailVisible = true
      } catch (error) { /* 统一请求拦截器显示错误 */ }
    },
    async approve() {
      if (this.saving) return
      const pending = (this.detail.recordList || []).find(row => row.approvalStatus === '1')
      if (!pending) return this.$message.warning('当前审批节点已变化，请刷新')
      this.saving = true
      try {
        await this.$axios.post(api.approve, { relatedId: this.detail.transferId, recordId: pending.recordId, approvalStatus: this.decision, approvalComments: this.comments })
        this.detailVisible = false; await this.load()
      } catch (error) { await this.openDetail(this.detail, true) } finally { this.saving = false }
    },
    async cancel(row) {
      if (this.saving) return
      try {
        await this.$confirm('取消后，暂扣收益金将返还至客户可用收益金。确定取消？', '取消申请', { type: 'warning' })
        this.saving = true
        await this.$axios.post(api.cancel, { transferId: row.transferId })
        await this.load()
      } catch (error) { /* 取消确认或请求失败均保留列表 */ } finally { this.saving = false }
    },
    async download(row) {
      if (this.exporting) return
      this.exporting = true
      try {
        const response = await this.$axios.post(api.exportPdf, { transferId: row.transferId }, { responseType: 'blob' })
        if (!response.data || !response.data.type.includes('pdf')) throw new Error('服务器未返回有效PDF')
        const url = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url; link.download = '收益金转商城积分申请表-' + row.transferNumber + '.pdf'
        document.body.appendChild(link); link.click(); link.remove()
        setTimeout(() => URL.revokeObjectURL(url), 1000)
      } catch (error) { this.$message.error(error.message || '导出失败') } finally { this.exporting = false }
    }
  }
}
</script>

<style scoped>
.detail-form { display: grid; grid-template-columns: 1fr 1fr; }
.detail-form .el-form-item { margin-bottom: 10px; overflow-wrap: anywhere; }
.mb15 { margin-bottom: 15px; }
.attachment-section { margin: 8px 0 18px; }
</style>
